import Vue from 'vue'
import Qs from 'qs'
import md5 from 'js-md5'
import router from '../router'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//API
// 本地环境
const System_Name = "本地环境"
// const Url_Base = "http://localhost:8083/WebTwoApi/"
// 测试环境
//--------test.aptus.fit--------
// const System_Name = "请注意，这是测试版！"
// const Url_Base = "http://api.aptus.fit:8083/WebTwoApi/"
// 生产环境
//--------guanli.aptus.fit--------
// const System_Name = "智能综合力量训练机器人后台管理系统"
const Url_Base = "http://api.aptusfit.com:8083/WebTwoApi/"
// 框架基本功能
const Url_login = Url_Base + "login"
const Url_checkLoginStatus = Url_Base + "checkLoginStatus"
const Url_getPermissionsTreeForMySelf = Url_Base + "getPermissionsTreeForMySelf"
const Url_getPermissionsTree = Url_Base + "getPermissionsTree"
const Url_changePwdWhenHaveLogin = Url_Base + "changePwdWhenHaveLogin"
const Url_getUnitTree = Url_Base + "getUnitTree"
const Url_getUnitAndProjectTree = Url_Base + "getUnitAndProjectTree"
const Url_findUnitByKeyWord = Url_Base + "findUnitByKeyWord"
const Url_addOrganization = Url_Base + "addOrganization"
const Url_editOrganization = Url_Base + "editOrganization"
const Url_deleteOrganization = Url_Base + "deleteOrganization"
const Url_listRole = Url_Base + "listRole"
const Url_addRole = Url_Base + "addRole"
const Url_editRole = Url_Base + "editRole"
const Url_deleteRole = Url_Base + "deleteRole"
const Url_getRolePermissions = Url_Base + "getRolePermissions"
const Url_saveRolePermissions = Url_Base + "saveRolePermissions"
const Url_getUsersByCombinationConditions = Url_Base + "getUsersByCombinationConditions"
const Url_getUsersNumByCombinationConditions = Url_Base + "getUsersNumByCombinationConditions"
const Url_addUser = Url_Base + "addUser"
const Url_editUser = Url_Base + "editUser"
const Url_editUserStatus = Url_Base + "editUserStatus"
const Url_listProject = Url_Base + "listProject"
const Url_numProject = Url_Base + "numProject"
const Url_UploadExcel = Url_Base + "uploadExcel"
const Url_UploadImage = Url_Base + "Upload/image"
//Aptus
const Url_GvList = Url_Base + "Gv/list"
const Url_GvNum = Url_Base + "Gv/num"
const Url_GvUpdate = Url_Base + "Gv/update"
const Url_TerminalUserList = Url_Base + "TerminalUser/list"
const Url_TerminalUserNum = Url_Base + "TerminalUser/num"
const Url_TerminalUserEdit = Url_Base + "TerminalUser/edit"
const Url_TrainPlanList = Url_Base + "TrainPlan/list"
const Url_TrainPlanNum = Url_Base + "TrainPlan/num"
const Url_DietaryPlanExecuteList = Url_Base + "DietaryPlanExecute/list"
const Url_DietaryPlanExecuteNum = Url_Base + "DietaryPlanExecute/num"
const Url_BodyFatScalesList = Url_Base + "BodyFatScales/list"
const Url_BodyFatScalesNum = Url_Base + "BodyFatScales/num"
const Url_CaloriesStatisticalList = Url_Base + "CaloriesStatistical/list"
const Url_CaloriesStatisticalNum = Url_Base + "CaloriesStatistical/num"
const Url_NoticeInsert = Url_Base + "Notice/insert"
const Url_NoticeDelete = Url_Base + "Notice/delete"
const Url_NoticeUpdate = Url_Base + "Notice/update"
const Url_NoticeList = Url_Base + "Notice/list"
const Url_NoticeNum = Url_Base + "Notice/num"
const Url_NoticeNeedReadInsert = Url_Base + "NoticeNeedRead/insert"
const Url_NoticeNeedReadDelete = Url_Base + "NoticeNeedRead/delete"
const Url_NoticeNeedReadList = Url_Base + "NoticeNeedRead/list"
const Url_NoticeNeedReadNum = Url_Base + "NoticeNeedRead/num"
const Url_DeviceInsert = Url_Base + "Device/insert"
const Url_DeviceDelete = Url_Base + "Device/delete"
const Url_DeviceUpdate = Url_Base + "Device/update"
const Url_DeviceList = Url_Base + "Device/list"
const Url_DeviceNum = Url_Base + "Device/num"
const Url_HelpCenterInsert = Url_Base + "HelpCenter/insert"
const Url_HelpCenterDelete = Url_Base + "HelpCenter/delete"
const Url_HelpCenterUpdate = Url_Base + "HelpCenter/update"
const Url_HelpCenterList = Url_Base + "HelpCenter/list"
const Url_HelpCenterNum = Url_Base + "HelpCenter/num"
const Url_FeedbackUpdate = Url_Base + "Feedback/update"
const Url_FeedbackList = Url_Base + "Feedback/list"
const Url_FeedbackNum = Url_Base + "Feedback/num"
const Url_DeviceAlarmList = Url_Base + "Device/alarmList"
const Url_DeviceAlarmNum = Url_Base + "Device/alarmNum"
const Url_DeviceBindblesnInsert = Url_Base + "DeviceBindblesn/insert"
const Url_DeviceBindblesnDelete = Url_Base + "DeviceBindblesn/delete"
const Url_DeviceBindblesnUpdate = Url_Base + "DeviceBindblesn/update"
const Url_DeviceBindblesnList = Url_Base + "DeviceBindblesn/list"
const Url_DeviceBindblesnNum = Url_Base + "DeviceBindblesn/num"
//WebTwo
const Url_TrainReportList = Url_Base + "TrainReport/list"
const Url_TrainReportNum = Url_Base + "TrainReport/num"
const Url_TrainPlanMyList = Url_Base + "TrainPlanMy/list"
const Url_TrainPlanMyNum = Url_Base + "TrainPlanMy/num"
const Url_ActionDatabaseInsert = Url_Base + "ActionDatabase/insert"
const Url_ActionDatabaseBatchInsert = Url_Base + "ActionDatabase/batchInsert"
const Url_ActionDatabaseDelete = Url_Base + "ActionDatabase/delete"
const Url_ActionDatabaseUpdate = Url_Base + "ActionDatabase/update"
const Url_ActionDatabaseList = Url_Base + "ActionDatabase/list"
const Url_ActionDatabaseNum = Url_Base + "ActionDatabase/num"
const Url_CourseDatabaseInsert = Url_Base + "CourseDatabase/insert"
const Url_CourseDatabaseDelete = Url_Base + "CourseDatabase/delete"
const Url_CourseDatabaseUpdate = Url_Base + "CourseDatabase/update"
const Url_CourseDatabaseList = Url_Base + "CourseDatabase/list"
const Url_CourseDatabaseNum = Url_Base + "CourseDatabase/num"
const Url_CourseActionInsert = Url_Base + "CourseAction/insert"
const Url_CourseActionDelete = Url_Base + "CourseAction/delete"
const Url_CourseActionUpdate = Url_Base + "CourseAction/update"
const Url_CourseActionList = Url_Base + "CourseAction/list"
const Url_CourseActionParameterInsert = Url_Base + "CourseActionParameter/insert"
const Url_CourseActionParameterDelete = Url_Base + "CourseActionParameter/delete"
const Url_CourseActionParameterUpdate = Url_Base + "CourseActionParameter/update"
const Url_TrainPlanDatabaseInsert = Url_Base + "TrainPlanDatabase/insert"
const Url_TrainPlanDatabaseDelete = Url_Base + "TrainPlanDatabase/delete"
const Url_TrainPlanDatabaseUpdate = Url_Base + "TrainPlanDatabase/update"
const Url_TrainPlanDatabaseList = Url_Base + "TrainPlanDatabase/list"
const Url_TrainPlanDatabaseNum = Url_Base + "TrainPlanDatabase/num"
const Url_TrainPlanDatabaseSubUpdate = Url_Base + "TrainPlanDatabaseSub/update"
const Url_TrainPlanDatabaseSubList = Url_Base + "TrainPlanDatabaseSub/list"
const Url_HomeGet = Url_Base + "Home/get"
//Reward Achievement
const Url_RewardAdd = Url_Base + "admin/achievement/reward/add"
const Url_RewardEdit = Url_Base + "admin/achievement/reward/edit"
const Url_RewardDelete = Url_Base + "admin/achievement/reward/delete"
const Url_RewardList = Url_Base + "admin/achievement/reward/list"
const Url_RewardDetail = Url_Base + "admin/achievement/reward"
const Url_ExchangeList = Url_Base + "admin/achievement/exchange/list"
const Url_ExchangeShip = Url_Base + "admin/achievement/exchange/ship"

export default {
  System_Name,
  Url_login,
  Url_checkLoginStatus,
  Url_getPermissionsTreeForMySelf,
  Url_getPermissionsTree,
  Url_changePwdWhenHaveLogin,
  Url_getUnitTree,
  Url_getUnitAndProjectTree,
  Url_findUnitByKeyWord,
  Url_addOrganization,
  Url_editOrganization,
  Url_deleteOrganization,
  Url_listRole,
  Url_addRole,
  Url_editRole,
  Url_deleteRole,
  Url_getRolePermissions,
  Url_saveRolePermissions,
  Url_getUsersByCombinationConditions,
  Url_getUsersNumByCombinationConditions,
  Url_addUser,
  Url_editUser,
  Url_editUserStatus,
  Url_listProject,
  Url_numProject,
  Url_UploadExcel,
  Url_UploadImage,
  Url_Base,
  //Aptus
  Url_GvList,
  Url_GvNum,
  Url_GvUpdate,
  Url_TerminalUserList,
  Url_TerminalUserNum,
  Url_TerminalUserEdit,
  Url_TrainPlanList,
  Url_TrainPlanNum,
  Url_DietaryPlanExecuteList,
  Url_DietaryPlanExecuteNum,
  Url_BodyFatScalesList,
  Url_BodyFatScalesNum,
  Url_CaloriesStatisticalList,
  Url_CaloriesStatisticalNum,
  Url_NoticeInsert,
  Url_NoticeDelete,
  Url_NoticeUpdate,
  Url_NoticeList,
  Url_NoticeNum,
  Url_NoticeNeedReadInsert,
  Url_NoticeNeedReadDelete,
  Url_NoticeNeedReadList,
  Url_NoticeNeedReadNum,
  Url_DeviceInsert,
  Url_DeviceDelete,
  Url_DeviceUpdate,
  Url_DeviceList,
  Url_DeviceNum,
  Url_HelpCenterInsert,
  Url_HelpCenterDelete,
  Url_HelpCenterUpdate,
  Url_HelpCenterList,
  Url_HelpCenterNum,
  Url_FeedbackUpdate,
  Url_FeedbackList,
  Url_FeedbackNum,
  Url_DeviceAlarmList,
  Url_DeviceAlarmNum,
  Url_DeviceBindblesnInsert,
  Url_DeviceBindblesnDelete,
  Url_DeviceBindblesnUpdate,
  Url_DeviceBindblesnList,
  Url_DeviceBindblesnNum,
  //WebTwo
  Url_TrainReportList,
  Url_TrainReportNum,
  Url_TrainPlanMyList,
  Url_TrainPlanMyNum,
  Url_ActionDatabaseInsert,
  Url_ActionDatabaseBatchInsert,
  Url_ActionDatabaseDelete,
  Url_ActionDatabaseUpdate,
  Url_ActionDatabaseList,
  Url_ActionDatabaseNum,
  Url_CourseDatabaseInsert,
  Url_CourseDatabaseDelete,
  Url_CourseDatabaseUpdate,
  Url_CourseDatabaseList,
  Url_CourseDatabaseNum,
  Url_CourseActionInsert,
  Url_CourseActionDelete,
  Url_CourseActionUpdate,
  Url_CourseActionList,
  Url_CourseActionParameterInsert,
  Url_CourseActionParameterDelete,
  Url_CourseActionParameterUpdate,
  Url_TrainPlanDatabaseInsert,
  Url_TrainPlanDatabaseDelete,
  Url_TrainPlanDatabaseUpdate,
  Url_TrainPlanDatabaseList,
  Url_TrainPlanDatabaseNum,
  Url_TrainPlanDatabaseSubUpdate,
  Url_TrainPlanDatabaseSubList,
  Url_HomeGet,
  Url_Base,
  //Reward Achievement
  Url_RewardAdd,
  Url_RewardEdit,
  Url_RewardDelete,
  Url_RewardList,
  Url_RewardDetail,
  Url_ExchangeList,
  Url_ExchangeShip
}

Vue.prototype.FunGetSign = function (data){
  var newData = {};
  Object.keys(data).sort().map(key => {
    var databuf = String(data[key])
    if(databuf.length > 0 )
    {
      newData[key] = databuf
    }
  })
  newData['authToken'] = localStorage.getItem('authToken')
  var str = decodeURIComponent(Qs.stringify(newData))
  // console.log(str)
  str = md5(str)
  // console.log(str)
  str = md5(str)
  // console.log(str)
  return str.toUpperCase()
};

//始终提醒接口的操作结果
Vue.prototype.FunRemindAllways = function (msg) {
  Vue.prototype.$alert(msg, '提示', {
    confirmButtonText: '确定',
    callback: action => {
    }
  });
};

//接口出现异常才提醒
Vue.prototype.FunRemindOnlyError = function (data) {
  if(data.code == 0){
    this.FunRemindAllways(data.msg);
  }
};

//接口出现网络异常才提醒
Vue.prototype.FunRemindNetWorkError = function (error) {
  this.FunRemindAllways('网络异常');
  console.log(error)
};

Vue.prototype.Quit = function (msg) {
  Vue.prototype.$notify.info({
    title: '提示',
    message: msg,
    duration: 5000
  });
  //清空数据
  localStorage.setItem('authToken', '')
  localStorage.setItem('userAvatar', '')
  localStorage.setItem('userId', '')
  localStorage.setItem('userName', '')
  //跳转
  router.push('/Login')
}

//UUID
Vue.prototype.FunGetUUID = function () {
  function S4() {
  		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  	}
  	return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
};

//双倍UUID
Vue.prototype.FunGetUUIDDouble = function () {
  	return Vue.prototype.FunGetUUID() + Vue.prototype.FunGetUUID();
};

//
Vue.prototype.FunBoolToInt = function (v) {
  if(v){
    return 1
  } else {
    return 0
  }
};

//
Vue.prototype.FunIntToBool = function (v) {
  if(v == 1){
    return true
  } else {
    return false
  }
};

//校验当前用户是否有权限
Vue.prototype.FunCheckSubRule = function (nameen,callback) {
  var userid = localStorage.getItem('userid')
  var timestamp = Date.parse(new Date())/1000
  var data = {
    userid: userid,
    timestamp:timestamp,
    rulename:nameen
  }
  //加上签名
  data['sign'] = Vue.prototype.FunGetSign(data)
  axios.post(Vue.prototype.global.Url_GetSubRuleStaus, Qs.stringify(data))
    .then(function (response) {
      callback(response)
    })
    .catch(function (error) {
      console.log(error)
    })
}

//获取
Vue.prototype.FunGetBaseSignData = function () {
  var data = {
    tempUuid: localStorage.getItem('tempUuid'),
    timestamp: Date.parse(new Date())
  }
  return data;
}

//获取当前时间格式化字符串
Vue.prototype.FunGetTimestamp = function () {
  var timestamp = Date.parse(new Date()) / 1000;
  return timestamp;
}

//获取当前时间格式化字符串
Vue.prototype.FunGetTimeStringShort = function () {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
  var now = today.getFullYear() + '-' + month + '-' + day;
  return now;
}

//获取当前时间格式化字符串
Vue.prototype.FunGetTimeStringShortFirst = function () {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  var now = today.getFullYear() + '-' + month + '-01';
  return now;
}

//获取当前时间格式化字符串
Vue.prototype.FunGetTimeStringLong = function () {
  var today = new Date();
  var month = today.getMonth() + 1;
  month = month < 10 ? '0'+month : month;
  var day = today.getDate() < 10 ? '0'+today.getDate() : today.getDate();
  var hours = today.getHours() < 10 ? '0'+today.getHours() : today.getHours();
  var mins = today.getMinutes() < 10 ? '0'+today.getMinutes() : today.getMinutes();
  var secs = today.getSeconds() < 10 ? '0'+today.getSeconds() : today.getSeconds();
  var now = today.getFullYear() + '-' + month + '-' + day + ' ' + hours + ":" + mins + ":" + secs ;
  return now;
}

/**
* 判断是否是数字
**/
Vue.prototype.isNumber = function (val){
  // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除，
  if(val === "" || val ==null){
    return false;
  }

  if(!isNaN(val)){
    //对于空数组和只有一个数值成员的数组或全是数字组成的字符串，isNaN返回false，例如：'123'、[]、[2]、['123'],isNaN返回false,
    //所以如果不需要val包含这些特殊情况，则这个判断改写为if(!isNaN(val) && typeof val === 'number' )
    return true;
  } else {
    return false;
  }
}

/**
* 将总电量转换成以万为单位
**/
Vue.prototype.ConvertPeTotal = function (val){
  var result = parseFloat(val);
  if(result >= 1000000){
    result = result / 10000
    result = result.toFixed(2)
    result = result + '万'
  }
  return result
}

/**
* 将数组转换成{x}{y}{z}这样的格式
**/
Vue.prototype.ConvertArrayToString = function (arr){
  var rv = "";
  arr.forEach(function (element) {
    rv = rv + "{"+element+"}";
  });
  return rv
}

/**
* 将{x}{y}{z}这样的格式转换成数组
**/
Vue.prototype.ConvertStringToArray = function (s){
  // 使用正则表达式匹配大括号中的数字
  const regex = /\{(\d+)\}/g;
  // const matches = [...s.matchAll(regex)].map(match => parseInt(match[1], 10));
  const matches = [...s.matchAll(regex)].map(match => match[1]);
  return matches;
}
